import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, MessageCircle } from "lucide-react";
import { POSTS } from "@/data/posts";
import { WHATSAPP_URL } from "@/data/site";

export default function BlogPost() {
  const { slug } = useParams();
  const post = POSTS.find((p) => p.slug === slug) || POSTS[0];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <div data-testid={`blog-post-${post.slug}`} className="min-h-screen bg-[#FAF9F6]">
      <header className="border-b border-slate-200 bg-white/70 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-5">
          <span className="font-display text-lg font-extrabold tracking-tight text-slate-900">
            SOCIFY<span className="text-[#1D4ED8]">.</span>
          </span>
          <a
            data-testid="blog-post-back-link"
            href="/blog"
            className="group flex items-center gap-2 rounded-full border border-slate-300 px-4 py-2 text-xs font-bold text-slate-700 transition-colors hover:bg-slate-900 hover:text-white"
          >
            <ArrowLeft className="h-3.5 w-3.5 transition-transform group-hover:-translate-x-0.5" />
            Volver al blog
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-16">
        <motion.article
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="mb-6 flex flex-wrap items-center gap-3">
            <span className="rounded-full bg-[#1D4ED8]/10 px-3 py-1 font-mono-sig text-[10px] font-bold uppercase tracking-widest text-[#1D4ED8]">
              {post.category}
            </span>
            <span className="font-mono-sig text-[10px] uppercase tracking-widest text-slate-400">
              {new Date(post.date).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" })} · {post.readTime} de lectura
            </span>
          </div>
          <h1 className="mb-12 font-display text-3xl sm:text-5xl font-extrabold leading-tight tracking-tight text-slate-900">
            {post.title}
          </h1>

          <div className="space-y-10">
            {post.sections.map((s) => (
              <section key={s.h}>
                <h2 className="mb-3 font-display text-xl sm:text-2xl font-bold text-slate-900">{s.h}</h2>
                {s.p.map((par, i) => (
                  <p key={i} className="mb-3 text-base leading-relaxed text-slate-600">
                    {par}
                  </p>
                ))}
              </section>
            ))}
          </div>

          <div className="mt-16 rounded-3xl bg-slate-950 p-8 sm:p-10">
            <p className="font-mono-sig text-[10px] font-bold uppercase tracking-[0.3em] text-[#00F0FF]">
              ¿Lo hacemos por ti?
            </p>
            <p className="mt-3 font-display text-2xl font-bold text-white">
              Tu negocio puede ser el siguiente en despegar.
            </p>
            <a
              data-testid="blog-post-whatsapp-cta"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-6 py-3.5 text-sm font-bold text-white transition-transform hover:scale-105"
            >
              <MessageCircle className="h-4 w-4" />
              Hablar por WhatsApp
            </a>
          </div>
        </motion.article>
      </main>
    </div>
  );
}
